export const calendarConfig = {
  viewType: "Month" as const,
  locale: "pl-pl",
  eventHeight: 60,
  cellHeight: 160,
  headerHeight: 30,
  eventMoveHandling: "Disabled" as const,
  eventResizeHandling: "Disabled" as const,
  timeRangeSelectedHandling: "Enabled" as const,
  eventStackingLineHeight: 52,
  showMoreEnabled: true,
  cellHeaderHeight: 24,
  theme: "month_default",
  onBeforeCellRender: (args: any) => {
    args.cell.html = `<div style="font-weight: 700; color: #000000; font-size: 14px; height: 24px; line-height: 24px;">${args.cell.start.toString("M/d")}</div>`;
  },
};
